import React, { useState, useEffect } from 'react'
import {
  FormControlLabel,
  Grid,
  Paper,
  Slide,
  AppBar,
  Dialog,
  Toolbar,
  makeStyles,
  IconButton,
  Typography,
  DialogContent,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import { ToolbarLines } from '../ToolbarLines';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector, useDispatch } from 'react-redux';
import { LineaPrestacionItem } from './LineaPrestacionItem';
import { cleanLineasPrestacion, getLineasPrestacion, getMotivosDebitos } from '../../../../../actions/liquidaciones/liquidaciones';
import { LIQUIDACIONES_LINEA_COMPORBANTE } from '../../../../../utils/constants';
import { TableHeadLineasPrestacion } from './TableHeadLineasPrestacion';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ModalLineasPrestacion = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { open, closeModalHandler, formatCurrencyPesos, comprobanteSeleccionado, disabled } = props;
  const { lineasPrestacionComprobante: items } = useSelector(
    (state) => state.liquidaciones
  );

  const [orderBy, setOrderBy] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [order, setOrder] = useState("asc");
  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);
  const componentRef = React.useRef();


  const screenHeight = window.screen.availHeight;
  const maxHeight = screenHeight < 800
    ? screenHeight * .90
    : screenHeight < 1000
      ? (screenHeight * .65) + 45
      : (screenHeight * .65) + 140;

  useEffect(() => {
    dispatch(cleanLineasPrestacion());
    if (comprobanteSeleccionado?.idComprobante && open)
      dispatch(getLineasPrestacion(comprobanteSeleccionado?.idComprobante));
  }, [dispatch, comprobanteSeleccionado?.idComprobante, open]);

  useEffect(() => {
    dispatch(getMotivosDebitos());
  }, [dispatch])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    scrollToTop();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const totalLineas = items.reduce((acum, item) => {
    return acum + ((item.importe * item.cantidad) + item.importeDebito - item.importeDebitoCalculadoCos ?? 0);
  }, 0);

  const totalCF = items.reduce((acum, item) => {
    return acum + (item.importeDebitoCalculadoCos ?? 0);
  }, 0);

  const info = () => {
    const idSolicudes = items.length > 0 && comprobanteSeleccionado.idsSolicitudesLiquidaciones
      ? `IdSolicitudes: ${comprobanteSeleccionado.idsSolicitudesLiquidaciones} / `
      : '';

    return `${idSolicudes}Cant. Lineas: ${items.length}`;
  }

  // const totalCoseguroFact = items.reduce((acum, item) => {
  //   return acum + item.coseguroFacturado;
  // }, 0)

  const scrollToTop = () => {
    if (open && componentRef.current) {
      componentRef.current.scrollIntoView();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      scrollToTop()
    }, 100)
  }, []);

  return (
    <Dialog
      fullScreen
      open={open}
      // maxWidth="md"
      onClose={closeModalHandler}
      TransitionComponent={Transition}
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={closeModalHandler} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Líneas Prestación
          </Typography>
          {/* <Button autoFocus color="inherit" onClick={() => {alert('guardando cambios')}}>
            Guardar
          </Button> */}
          {/* <Typography variant="body1" style={{display: 'grid'}}>
            <span style={{textAlign: 'right'}}>{`Importe Líneas: ${formatCurrencyPesos(totalLineas)}`}</span>
            <span style={{textAlign: 'right'}}>{info()}</span>
          </Typography> */}
          <Typography variant="body1" style={{ display: 'grid', marginRight: 100 }}>
            <span style={{ textAlign: 'right' }}>{`Total Comprobante: ${formatCurrencyPesos(comprobanteSeleccionado?.totalComprobante)}`}</span>
            <span style={{ textAlign: 'right' }}>{`Total Líneas: ${formatCurrencyPesos(comprobanteSeleccionado?.totalLineasComprobante)}`}</span>
          </Typography>
          <Typography variant="body1" style={{ display: 'grid', marginRight: 100 }}>
            <span style={{ textAlign: 'right' }}>{`Total Débitos: ${formatCurrencyPesos(comprobanteSeleccionado?.totalDebitosLineasComprobante)}`}</span>
            {/* CALCULO MODIFICADO SACO -TotalCoseguroFacturado -
            <span style={{ textAlign: 'right' }}>{`Total A Pagar: ${formatCurrencyPesos((comprobanteSeleccionado?.totalLineasComprobante + comprobanteSeleccionado?.totalDebitosLineasComprobante - totalCoseguroFact))}`}</span> */}
            <span style={{ textAlign: 'right' }}>{`Total Coseguro Facturado: ${formatCurrencyPesos(totalCF)}`}</span>
            {/* <span style={{ textAlign: 'right' }}>{`Total A Pagar: ${formatCurrencyPesos((comprobanteSeleccionado?.totalLineasComprobante + comprobanteSeleccionado?.totalDebitosLineasComprobante))}`}</span> */}
          </Typography>
          <Typography variant="body1" style={{ display: 'grid' }}>
            <span style={{ textAlign: 'right' }}>{`Total a Pagar: ${formatCurrencyPesos(totalLineas)}`}</span>
            {/* <span style={{ textAlign: 'right' }}>{`Líneas Prestación: ${formatCurrencyPesos(totalLineas)}`}</span> */}
            <span style={{ textAlign: 'right' }}>{info()}</span>
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent /* style={{ overflowY: "hidden"}} */>
        <Grid container>
          <ToolbarLines
            disabled={disabled}
            formatCurrencyPesos={formatCurrencyPesos}
            lineaComprobante={LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION}
            comprobanteSeleccionado={comprobanteSeleccionado}
          />
          <Grid item xs={12} style={{ height: '100%' }}>
            <TableContainer component={Paper} style={{ overflowX: "auto", overflowY: "scroll", height: maxHeight }}>
              <Table stickyHeader size={dense ? "small" : "medium"} ref={componentRef} aria-label="sticky table">
                <TableHeadLineasPrestacion
                  classes={classes}
                  {...{ order, orderBy }}
                  onRequestSort={handleRequestSort}
                  comprobanteSeleccionado={comprobanteSeleccionado}
                />
                <TableBody>
                  {items.length > 0 ? (
                    stableSort(items, getComparator(order, orderBy))
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((item, i) => (
                        <LineaPrestacionItem
                          item={item}
                          key={item.idItem}
                          disabledLinea={disabled}
                          nroLinea={(i + 1) + (page * rowsPerPage)}
                          formatCurrencyPesos={formatCurrencyPesos}
                          comprobanteSeleccionado={comprobanteSeleccionado}
                          lineaComprobante={LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION}
                        />
                      ))
                  ) : (
                    <TableRow style={{ height: 100 }}>
                      <TableCell
                        colSpan={13}
                        style={{ textAlign: "-webkit-center" }}
                      >
                        {" "}
                        Sin Registros
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {items.length > 0 && (
              <>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justify="space-between"
                  style={{ marginTop: 10 }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={dense}
                        onChange={(e) => setDense(e.target.checked)}
                      />
                    }
                    label="Tamaño compacto"
                  />
                  <TablePagination
                    style={{ backgroundColor: "white" }}
                    rowsPerPageOptions={[100, 200, 500]}
                    component="div"
                    count={items.length}
                    rowsPerPage={rowsPerPage}
                    labelRowsPerPage="Registros por página"
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
